export default "__VITE_ASSET__0577dd93__"